var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 5.9585L14.625 9.2085L11.375 9.2085L11.375 5.9585L14.625 5.9585Z",
    fill: "black",
    fillOpacity: 0.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 11.3752L14.625 14.6252L11.375 14.6252L11.375 11.3752L14.625 11.3752Z",
    fill: "black",
    fillOpacity: 0.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 20.0418L14.625 16.7918L11.375 16.7918L11.375 20.0418L14.625 20.0418Z",
    fill: "black",
    fillOpacity: 0.48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.f2626c7c493cd6ed83f0deabc5761c60.svg";
export { ForwardRef as ReactComponent };